/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowUiAuthLogoutIcon64Regular = forwardRef('ArrowUiAuthLogoutIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M21.5 9a7.5 7.5 0 0 0-7.5 7.5v31a7.5 7.5 0 0 0 7.5 7.5H38a1.5 1.5 0 0 1 0 3H21.5C15.701 58 11 53.299 11 47.5v-31C11 10.701 15.701 6 21.5 6H38a1.5 1.5 0 0 1 0 3H21.5Z" }),
        React.createElement("path", { d: "M46.19 18.94a1.5 1.5 0 0 0 0 2.12l9.439 9.44H25a1.5 1.5 0 0 0 0 3h30.629l-9.44 9.44a1.5 1.5 0 0 0 2.122 2.12l9.878-9.878a4.5 4.5 0 0 0 0-6.364l-9.878-9.879a1.5 1.5 0 0 0-2.122 0Z" })));
});
